// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/chunks/" + {"314":"games-page","449":"guild","876":"billing"}[chunkId] + ".js?id=" + {"314":"2c1f2fb5c9ea3cfc","449":"56ac01032ba8a7d0","876":"a92f098dfaefb28c"}[chunkId] + "";
};